import { useEffect, useState } from 'react';
import { useOrderStore } from '../../../store/useOrder';
import { useLocation } from 'react-router-dom';
import { formatDate } from '../../../util/util';

/**
 * @description 주문 확정 페이지 - 10초 후 새로고침됩니다 텍스트 + 정지 기능
 */
const OFReloadText = () => {
  const [count, setCount] = useState<number>(10);
  const [date, setDate] = useState<string>('');
  const [isPaused, setIsPaused] = useState<boolean>(false);
  const { getOrders } = useOrderStore();

  const { search } = useLocation();

  useEffect(() => {
    // URL query string을 객체로 변환
    const queryParams = new URLSearchParams(search);
    const queryObject: Record<string, string> = {};
    queryParams.forEach((value, key) => {
      queryObject[key] = value;
    });

    // isPaused가 false 일 때만 동작
    if (!isPaused) {
      // 카운트가 0이면 getOrders 호출 후 카운트 리셋
      if (count === 0) {
        getOrders({ ...queryObject, confirmYn: 'Y' });
        setCount(10);
        setDate(`${formatDate(new Date()).timestamp}`);
      }

      const interval = setInterval(() => {
        setCount(prevCount => prevCount - 1);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [count, getOrders, search, isPaused]);

  const togglePause = () => {
    setIsPaused(prev => !prev);
  };

  return (
    <div className="!flex !items-center !gap-2 !text-sm !text-gray-600">
      <button
        onClick={togglePause}
        className="!p-1 !rounded hover:!bg-gray-100 !transition-colors"
        title={isPaused ? '자동 새로고침 시작' : '자동 새로고침 일시정지'}
      >
        {isPaused ? (
          <svg className="!w-4 !h-4 !text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
          </svg>
        ) : (
          <svg className="!w-4 !h-4 !text-blue-500 !animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
        )}
      </button>
      <span className="!font-medium">
        {isPaused ? '일시정지됨' : (
          <>
            <span className="md:hidden">{`${count}초`}</span>
            <span className="hidden md:inline">{`${count}초 후 자동 새로고침`}</span>
          </>
        )}
      </span>
      {date && (
        <span className="!text-xs !text-gray-500 hidden md:inline">
          (최근: {date})
        </span>
      )}
    </div>
  );
};

export default OFReloadText;
